export default __webpack_public_path__ + "static/media/waiting.c7c7e646.gif";